module.exports = __webpack_public_path__ + "static/jll1-c177921db4343a61f5f3e9188e78e2d3.png";